import { useEffect } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { makeStyles, Paper, Grid, Hidden } from '@material-ui/core'
import { useHistory, useLocation } from 'react-router-dom'

import Footer from '../../Shell/Footer/Footer'
import LoginForm from '../../security/LoginForm'
import RequestPasswordReset from '../../security/RequestPasswordReset'
import ResetPassword from '../../security/ResetPassword'
import SuccessMessage from '../../security/SuccessMessage'
import RegisterForm from '../../security/UserRegister/RegisterForm/RegisterForm'
import FaqList from './FaqList'

import guiaTercerosImage from '../../../images/guia-terceros.png'
import { useStateValue } from 'context/store'

const renderLoginImage = props =>
   props.pathname == '/auth/user-register' ? `url(${guiaTercerosImage})` : 'url(/static/splash-login.png)'

const useStyles = makeStyles(theme => ({
   pageContainer: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column'
   },
   boxContainer: {
      flex: 1,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
   },
   box: {
      display: 'flex',
      width: 720,
      height: 'auto',
      minHeight: 510,
      margin: theme.spacing(1, 2)
   },
   viewContainer: {
      flex: 1
   },
   imageContainer: {
      display: 'flex',
      flex: 1
   },
   image: {
      backgroundImage: props => renderLoginImage(props),
      height: 'auto',
      backgroundSize: '100% 100%',
      position: 'relative',
      display: 'block',
      width: '100%',
      overflow: 'hidden',
      borderRadius: '0 4px 4px 0'
   }
}))

function InitPage() {
   let history = useHistory()
   let location = useLocation()
   const [{ sessionUser }] = useStateValue()
   const activeLogin = localStorage.getItem('user_settings')
   const classes = useStyles({ pathname: location.pathname })

   function goToDashboard() {
      history.push('/dashboard')
   }

   useEffect(() => {
      if (activeLogin) {
         goToDashboard()
      }
   }, [])

   return (
      <Grid className={classes.pageContainer}>
         <Grid className={classes.boxContainer}>
            <Paper className={classes.box}>
               <Grid className={classes.viewContainer}>
                  <Switch>
                     <Route exact path="/auth/login">
                        <LoginForm />
                     </Route>
                     <Route exact path="/auth/request-password-reset">
                        <RequestPasswordReset />
                     </Route>
                     <Route exact path="/auth/request-password-success">
                        <SuccessMessage type="requestPasswordReset" />
                     </Route>
                     <Route exact path="/auth/reset/:token">
                        {/* NOTA: Esta Route path va en el correo que se manda al usuario */}
                        <ResetPassword />
                     </Route>
                     <Route exact path="/auth/reset-success">
                        <SuccessMessage type="resetPassword" />
                     </Route>
                     <Route exact path="/auth/user-register">
                        <RegisterForm />
                     </Route>
                     <Route exact path="/userUpdated">
                        {/* Esta Route si se usa????? */}
                        <SuccessMessage type="userIsUpdated" />
                     </Route>
                     <Route path="/">
                        <Redirect to="/auth/login" />
                     </Route>
                  </Switch>
               </Grid>
               <Hidden xsDown>
                  <Grid className={classes.imageContainer}>
                     <Grid className={classes.image} />
                  </Grid>
               </Hidden>
            </Paper>
            <FaqList />
         </Grid>
         <Footer />
      </Grid>
   )
}

export default InitPage
